import React, { Component } from 'react';
import './index.less';
import classNames from 'classnames';

class Row extends Component {
    render () {
        let { children, className, style, ...others } = this.props;
        return <div 
            {...others}
            className={classNames('low-code-row', className)}
            style={style}
        >
            {children}
        </div>;
    }
}

export default Row;